<template>
  <b-button
    v-b-tooltip.hover.viewport.noninteractive="{
      title: text,
      disabled: !(icon || svg)
    }"
    :variant="isSvgButton ? null : 'primary'"
    :class="{ 'custom-group-action': isSvgButton }"
    @click="toggleSelection"
  >
    <img
      v-if="icon"
      src="/img/icons/select-all.svg"
      alt="select-all-icon"
    >

    <svg
      v-else-if="svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-grid2x2-check-icon lucide-grid-2x2-check"
    >
      <path d="M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3" />
      <path d="m16 19 2 2 4-4" />
    </svg>

    <template v-else>
      {{ text }}
    </template>
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectAllObjectsButton',

  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    svg: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    ...mapGetters('layout', [
      'allObjectsAreSelected',
      'selectedInstance',
    ]),
    text () {
      return this.allObjectsAreSelected ? 'Unselect All' : 'Select All'
    },
    isSvgButton () {
      return this.svg && !this.icon
    },
  },

  methods: {
    toggleSelection () {
      const objects = this.selectedInstance.canvas.getObjects()

      if (this.allObjectsAreSelected) {
        this.selectedInstance.canvas.discardActiveObject()
        this.$emit('unselected');
      } else if (objects.length) {
        this.selectedInstance.canvas.discardActiveObject()
        const selection = new fabric.ActiveSelection(objects, {
          canvas: this.selectedInstance.canvas
        })
        this.selectedInstance.canvas.setActiveObject(selection)
      }

      this.selectedInstance.canvas.requestRenderAll()
    },
  },
}
</script>

<style scoped lang="scss">
img {
  width: 1.5rem;
  scale: 2;
}
</style>
